import React from "react";
import './App.css';
import Navbar from "./Navbar";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";

function Rift(){
    return(
        <>
            <section id="rifts">
                <div className="content">
                <Navbar />
                <div className="container">
                    <div className="row rift-row" data-aos="zoom-in">
                        <div className="col-md-6 col-sm-12 col-12 col-lg-6">
                            <h1 className="rift-h1">
                                FROM THE VOID
                                THROUGH THE RIFT
                            </h1>
                            <p className="rift-p">
                                Forgotten Ethereal Worlds is a landscape NFT project.
                                345 Genesis. 3345 total supply.
                            </p>
                            <p className="rift-p second-p">
                            These worlds will include passive staking, token generation, and level progression. Token generated, $FRAGZ, allows explorers to awaken the maximum potential of their Forgotten Ethereal Worlds. It begins with accelerated world growth and rewriting history, truly making it their own.
                            </p>
                            <p className="rift-p">
                            Venture through the rift.<br></br>
                            Uncover the forgotten.
                            </p>
                            <a href="#second">
                                <button class="btn btn-lg asced-btn">
                                    Asced
                                </button>
                            </a>
                        </div>
                        <div className="col-md-6 col-sm-12 col-12 col-lg-6">
                            
                        </div>
                    </div>

                    <div className="row rift-row" id="second" data-aos="zoom-in">
                    <div className="col-md-6 col-sm-12 col-12 col-lg-6">
                            <h1 className="rift-h1">
                            BEGAN WITH A FEW<br />
                            THE FIRST OF US
                            </h1>
                            <p className="rift-p">
                            The core team is based in Melbourne and Malaysia with experience in crypto, trading, technology and art. Our aim to create beautiful pieces that grows along with the community whilst providing value along the way.
                            </p>
                            <div className="row box-row">
                                <div className="col-md-3 col-sm-12 col-12 col-lg-3 box box-1"  data-aos="flip-left">
                                    <h4 className="box-h4">
                                        TAKOA
                                    </h4>
                                    <p className="box-p">
                                        Project Lead
                                    </p>
                                </div>
                                <div className="col-md-3 col-sm-12 col-12 col-lg-3 box box-2"  data-aos="flip-left">
                                <h4 className="box-h4">
                                        SUIKON
                                    </h4>
                                    <p className="box-p">
                                        Creative Dev
                                    </p>
                                </div>
                                <div className="col-md-3 col-sm-12 col-12 col-lg-3 box box-3" data-aos="flip-left">
                                <h4 className="box-h4">
                                        EXCEED
                                    </h4>
                                    <p className="box-p">
                                        Community Lead
                                    </p>
                                </div>
                                <div className="col-md-3 col-sm-12 col-12 col-lg-3 box box-4" data-aos="flip-left">
                                <h4 className="box-h4">
                                        ALEX
                                    </h4>
                                    <p className="box-p">
                                        Lead Artist
                                    </p>
                                </div>
                            </div>
                            <p className="rift-p">
                            Trad Fi veteran with an analyst background in renewables. Likes photography and expensive JPEGs. Coin flip master.
                            </p>
                            <a href="#third">
                                <button class="btn btn-lg asced-btn">
                                    Connect
                                </button>
                            </a>
                    </div>
                    </div>


                    <div className="row rift-row" id="third" data-aos="zoom-in">
                    <div className="col-md-6 col-sm-12 col-12 col-lg-6">
                            <h1 className="rift-h1">
                            ESTABLISH THE<br />
CONNECTION
                            </h1>
                            <p className="rift-p">
                            A ray of hope has breached the darkness. The lost now have a way.
Many have seen the rift. Only a few have answered the call.
                            </p>

                            <div className="row first-row myrow">
                                <div className="col-md-4 col-sm-12 col-lg-4 col-12 link-box">
                                   <a href="/transmission"> <h1 className="first-row-h1">
                                        transmission
                                    </h1></a>
                                </div>
                                <div className="col-md-4 col-sm-12 col-lg-4 col-12 link-box link-box-2">
                                <a href="/map"><h1 className="first-row-h1">
                                        map
                                    </h1></a>
                                </div>
                            </div>

                            <div className="row first-row">
                                <div className="col-md-4 col-sm-12 col-lg-4 col-12 link-box">
                                <a href="#"><h1 className="first-row-h1">
                                        twitter
                                    </h1></a>
                                </div>
                                <div className="col-md-4 col-sm-12 col-lg-4 col-12 link-box link-box-2">
                                <a href="#"><h1 className="first-row-h1">
                                        discord
                                    </h1></a>
                                </div>
                            </div>
                         
                            
                    </div>
                    </div>
                </div>
                </div>
                </section>
        </>
    );
}

export default Rift;